import React, {useState, useMemo, useEffect} from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
  import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
  import { ModuleRegistry } from "@ag-grid-community/core";
  import { useNavigate } from "react-router-dom";
  import axios from "axios";
  import { apiUrl } from "../../../config/Config";

  import {
    faPlus,
  } from "@fortawesome/free-solid-svg-icons";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import { useSelector, useDispatch } from "react-redux";
  import Editor from "../../common/Editor";

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

const NewArticle = () => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const dispatch = useDispatch();
    const [forceupdate, setforceupdate] = useState(false);
    const [editorLoaded, setEditorLoaded] = useState(true);

    // const [title, settitle] = useState("");
    const [sdesc, setsdesc] = useState("");
    const [bimage, setbimage] = useState(null);
    const [bdesc, setbdesc] = useState("");

    const [articletype, setarticletype] = useState("");
        const [title, settitle] = useState("");
        const [description, setdescription] = useState("");
        const [minread, setminread] = useState("");
        const [image, setimage] = useState("");
        const [pdf, setpdf] = useState("");
        const [videourl, setvideourl] = useState("");

    const navigate = useNavigate();

    const handlesubmitcoupon = async(statusnum) => {
      if(articletype && title && image && description) {
        var data = {
          type: articletype,
          title: title,
          description: description,
          minread: minread,
          image: image,
          pdf: pdf,
          videourl: videourl
        }
        console.log('data >>', data);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "addnewarticle",data, headers)
          .then((res) => {
            // console.log('res >>', res.data)
            // category data
            if (res?.data?.status == "success") {
              navigate('/admin/articles')
            } else {
              if (res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} });
                navigate("/admin/login");
              } else {
                alert(res.data.message);
              }
            }
          })
          .catch((err) => {
            console.log("err >>", err);
          });
  
        
      }
      
      // 
    }

    const getBase64 = (file) => {
      return new Promise((resolve) => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();
  
        // Convert the file to base64 text
        reader.readAsDataURL(file);
  
        // on reader load somthing...
        reader.onload = () => {
          // Make a fileInfo Object
          // console.log("Called", reader);
          baseURL = reader.result;
          // console.log(baseURL);
          resolve(baseURL);
        };
        // console.log(fileInfo);
      });
    };

    const handleinputchange = async (file) => {
      var obj = {};
      await getBase64(file).then((result) => {
        obj["name"] = file.name;
        obj["image"] = result;
      });
      // console.log('obj >>', obj);
      setimage(obj);
    };

    const handleinputchange1 = async (file) => {
      var obj = {};
      await getBase64(file).then((result) => {
        obj["name"] = file.name;
        obj["image"] = result;
      });
      // console.log('obj >>', obj);
      setpdf(obj);
    };

    return (
      <div className="">
        <div className="dashboardbox" style={{ width: "100%" }}>
          <div className="inventorysave-row addproduct-save-row">
            <p className="inventorysummary-text addproduct-text">
              Create New Article
            </p>
            {/* <div className="inventory-save-btn add-product-btn add-product-btn1" onClick={() => {handlesubmitcoupon(0)}}>
              <p>Save as draft</p>
            </div> */}
            <div className="inventory-save-btn add-product-btn " style={{marginLeft: 'auto'}} onClick={() => {handlesubmitcoupon(1)}}>
              <p>Save & Publish</p>
            </div>
          </div>
          <div className="inventorysummaryrow row mt-3">
            <div className="col-md-4">
              <div className="">
                <label className="addproduct-label">Article Type *</label>
                <select className="form-control addproductinput" value={articletype} onChange={(t) => {setarticletype(t.target.value)}}>
                   <option value={""} disabled selected>Select type</option>
                   <option value={"Text"}>Text</option>
                   <option value={"PDF"}>PDF</option>
                   <option value={"Video"}>Video</option>
                </select>
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Title *</label>
                <input
                value={title}
                onChange={(t) => {settitle(t.target.value)}}
                  className="form-control addproductinput"
                  placeholder="Enter Title of Article"
                />
              </div>
              <div className="mt-3">
                <label className="addproduct-label">Minutes of Read</label>
                <input
                  value={minread}
                  onChange={(t) => {
                    setminread(t.target.value);
                  }}
                  type="number"
                  className="form-control addproductinput"
                  placeholder="Enter Minutes"
                />
              </div>
              <div className="mt-3">
                    <label className="addproduct-label">Article Image *</label>
                    <input
                    onChange={(t) => {
                      handleinputchange(t.target.files[0]);
                    }}
                      accept="image/*"
                      type="file"
                      className="form-control addproductinput"
                      placeholder="Article Image"
                    />
                  </div>
              
            </div>
            <div className="col-md-8">
              <div className="">
                <label className="addproduct-label">Article Details *</label>
                <div className="descriptionckeditor" style={{ marginTop: 7 }}>
                  <Editor
                    name="name"
                    value={description}
                    onChange={(data) => {
                      setdescription(data);
                    }}
                    editorLoaded={editorLoaded}
                    className="addproductinput"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  {
                    articletype == "Text" ?
                    null :
                    articletype == "PDF" ?
                    <div className="">
                    <label className="addproduct-label">Article PDF</label>
                    <input
                    onChange={(t) => {
                      handleinputchange1(t.target.files[0]);
                    }}
                      accept="pdf/*"
                      type="file"
                      className="form-control addproductinput"
                      placeholder="Article Image"
                    />
                    </div> : 
                  articletype == "Video" ?
                  <div className="">
                  <label className="addproduct-label">Video URL</label>
                  <input
                    value={videourl}
                    onChange={(t) => {
                      setvideourl(t.target.value);
                    }}
                    type="text"
                    className="form-control addproductinput"
                    placeholder="Enter Video Url"
                  />
                </div> : null
                  }
                  
                </div>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        </div>
      </div>
    );
}

export default NewArticle;